<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" :width="dialogWidth" :scrollable="true">
      <v-form ref="form" v-model="valid" @submit="confirm">
        <v-card>
          <v-card-title class="headline">{{$t('payoutToAccountDialog.title')}}</v-card-title>
          <v-card-text>
            <coin-balance :glow="false"/>
            <div class="mt-3">
              <span class="subtitle-1">{{$t('payoutToAccountDialog.to-account')}}</span>
            </div>
            <div class="mt-1 mb-3">
              <account-widget :account="account"/>
            </div>
            <div class="mt-3">
              <span class="subtitle-1">{{$t('payoutToAccountDialog.amount')}}</span>
            </div>
            <span>{{$t('payoutToAccountDialog.description')}}</span>
            <v-text-field
              append-icon="mdi-circle-multiple-outline"
              v-model="coins"
              :label="$t('payoutToAccountDialog.coins-label')"
              :rules="coinRule"
              type="number"
              filled
              v-debounce="loadPayoutCalculation"
              :disabled="loading"
              autocomplete="off"
              :hint="$t('payoutToAccountDialog.coins-hint')"
            ></v-text-field>
            <div class="mt-0">
              <span class="subtitle-1">{{$t('payoutToAccountDialog.payout')}}</span>
            </div>
            <div>
              <span class="payoutEuro">{{payoutEuro}}</span>
              <v-progress-circular
                v-if="previewLoading > 0"
                indeterminate
                color="primary"
                class="payoutLoading"
              ></v-progress-circular>
            </div>
            
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-flex>
              <v-btn
                class="me-2 mb-2"
                color="primary"
                data-test-id="confirmButton"
                type="submit"
                :disabled="!valid || previewLoading > 0"
                :loading="loading"
              >
                <v-icon left>mdi-currency-eur</v-icon>{{ $t("payoutToAccountDialog.payout-now") }}
              </v-btn>
              <v-btn :disabled="loading" color="secondary" @click="closeDialog()" class="me-2 mb-2">
                <v-icon left>mdi-close-circle</v-icon>{{$t('common.cancel')}}
              </v-btn>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import { ACTION_LOAD_COIN_ACCOUNT, MUTATION_RAISE_NOTIFICATION } from "@/plugins/store";
import AccountWidget from "./AccountWidget"
import CoinBalance from "@/widgets/CoinBalance"
import purchaseProduct from "@/mixins/purchaseProduct"

export default {
  name: "PayoutToAccountDialog",
  mixins: [purchaseProduct],
  components: {
    AccountWidget,
    CoinBalance,
  },
  props: {
    account: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    },
    closeAction: {
      type: Function,
      required: true
    },
    payoutDoneAction: {
      type: Function,
    }
  },
  data: function() {
    return {
      dialog: false,
      loading: false,
      previewLoading: 0,
      calculation: undefined,
      error: undefined,
      coins: undefined,
      valid: false,
      coinRule: [v => parseInt(v) > 0 || ''],
    };
  },
  computed: {
    dialogWidth: function() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return "500";
      } else if (this.$vuetify.breakpoint.smAndUp) {
        return "80%";
      }
      return "90%";
    },
    payoutEuro: function() {
      if (this.calculation) {
        return this.purchaseValueToString(this.calculation.value)
      } else {
        return this.purchaseValueToString(0.0)
      }
    }
  },
  watch: {
    visible: function(val) {
      // console.log('visible changed to ' + val)
      this.dialog = val;
    },
    dialog: function(val) {
      // console.log("dialog changed to " + val);
      if (val === false) {
        this.closeAction();
      }
    },
  },
  mounted() {
    this.dialog = this.visible
    this.$store.dispatch(ACTION_LOAD_COIN_ACCOUNT)
  },
  methods: {
    closeDialog() {
      this.closeAction();
    },
    confirm(e) {
      e.preventDefault();
      let data = {
        amount: this.coins
      }
      this.loading = true
      this.$api.coinPayoutToBankAccount(this.account.uid, data)
      .then(res => {
        this.loading = false
        let valueStr = this.purchaseValueToString(res.data.value)
        let msg = this.$t('payoutToAccountDialog.payout-success', {value: valueStr, amount: res.data.amount, account: this.account.name})
        this.$store.commit(MUTATION_RAISE_NOTIFICATION, {
            type: "success",
            message: msg
        });
        this.$store.dispatch(ACTION_LOAD_COIN_ACCOUNT)
        this.closeDialog()
        this.payoutDoneAction && this.payoutDoneAction();
      })
      .catch(error => {
        this.loading = false
        this.$common.onError(error)
      })
      return false
    },
    loadPayoutCalculation() {
      if (this.coins == '' || isNaN(this.coins) || this.coins < 0) {
        this.calculation = undefined
        return
      }
      let data = {
        amount: this.coins
      }
      this.previewLoading++
      this.$api.calculateCoinPayoutToBankAccount(this.account.uid, data)
      .then(res => {
        this.previewLoading--
        if (this.coins == res.data.amount) {
          this.calculation = res.data
        }
      })
      .catch(error => {
        this.calculation = undefined
        this.error = error
        this.previewLoading--
        this.$common.onError(error)
      })
    }
  }
};
</script>
<style scoped>
.payoutEuro {
  font-size: 120%;
}
.payoutLoading {
  width: 1em !important;
  height: 1em !important;
  margin-bottom: 0.3em;
  margin-left: 0.5em;
}
</style>